import { a as e, g as r, h as E, i as L } from "./variables-37cba309.js";
var n = ((a) => (a[a.DEFAULT = parseInt(e, 10)] = "DEFAULT", a[a.MEDIUM = parseInt(r, 10)] = "MEDIUM", a[a.LARGE = parseInt(E, 10)] = "LARGE", a[a.XLARGE = parseInt(L, 10)] = "XLARGE", a))(n || {});
export {
  n as B
};
